import React, { useEffect, useState } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { HiOutlineMenuAlt3, HiOutlineX } from "react-icons/hi";

const PHONE = "+91 99999 99999"; // ✅ replace
const WHATSAPP_NUMBER = "919999999999"; // ✅ replace
const WHATSAPP_TEXT = encodeURIComponent("Hi, I want to book a free CA consultation.");

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "About", href: "#about" },
  { label: "Process", href: "#process" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" }
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waHref = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

  return (
    <header className={`sticky top-0 z-40 w-full bg-white/80 backdrop-blur ${scrolled ? "border-b border-navy-900/10" : ""}`}>
      <div className="mx-auto max-w-7xl container-pad">
        <div className="flex h-16 items-center justify-between">
          <a href="/" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-navy-900 text-white flex items-center justify-center font-heading font-bold">
              CA
            </div>
            <div className="leading-tight">
              <div className="font-heading font-semibold text-navy-900">Sharma & Co.</div>
              <div className="text-xs text-navy-800/70">Chartered Accountants</div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} className="link text-sm font-medium">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="btn-secondary">
              <FaPhoneAlt /> Call Now
            </a>
            <a href={waHref} target="_blank" rel="noreferrer" className="btn-primary">
              <FaWhatsapp /> WhatsApp
            </a>
            <a href="#contact" className="btn-accent">
              Book Free Consultation
            </a>
          </div>

          <button
            className="lg:hidden inline-flex items-center justify-center rounded-xl border border-navy-900/10 bg-white px-3 py-2"
            onClick={() => setOpen((s) => !s)}
            aria-label="Open menu"
          >
            {open ? <HiOutlineX size={22} /> : <HiOutlineMenuAlt3 size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-navy-900/10 bg-white">
          <div className="mx-auto max-w-7xl container-pad py-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((l) => (
                <a key={l.href} href={l.href} className="link font-medium" onClick={() => setOpen(false)}>
                  {l.label}
                </a>
              ))}
              <div className="mt-3 grid grid-cols-1 gap-3">
                <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="btn-secondary w-full" onClick={() => setOpen(false)}>
                  <FaPhoneAlt /> Call Now
                </a>
                <a href={waHref} target="_blank" rel="noreferrer" className="btn-primary w-full" onClick={() => setOpen(false)}>
                  <FaWhatsapp /> WhatsApp
                </a>
                <a href="#contact" className="btn-accent w-full" onClick={() => setOpen(false)}>
                  Book Free Consultation
                </a>
              </div>
              <p className="small-muted mt-2">
                ✅ Trusted, on-time compliance • ✅ PAN-India support • ✅ Transparent pricing
              </p>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
